import { TMapTimeRange } from '@/console/features/map/map.types';
import { BACKUP_JOBS } from '@/shared/features/jobs/jobs.constants';
import { FeatureEnum } from '@/shared/types/types.generated';

export const MAP_MIN_ZOOM = 2;
export const MAP_MAX_ZOOM = 18;
export const MAP_SINGLE_LOCATION_ZOOM = 9;
export const MAP_DEFAULT_CENTER: [number, number] = [20, 0];
export const MAP_DEFAULT_ZOOM = 3;

// Set on the MapLibre canvas so the theme tile filter can target it like a raster tile.
export const MAP_GL_BASEMAP_CLASS = 'map-gl-basemap';

export const MAP_BASEMAP_USAGE_EVENT = 'basemap_used';

export const MAP_PAGE_SIZE = 5000;
export const MAP_DEFAULT_REFRESH_INTERVAL = 60000;
export const MAP_DEFAULT_TIME_RANGE: TMapTimeRange = '7d';

export const MAP_FEATURE_TYPE_OPTIONS = BACKUP_JOBS;
export const MAP_ALL_FEATURE_TYPES_VALUE = 'all';

export const MAP_DEFAULT_FEATURE_TYPES: FeatureEnum[] = [];

export const MAP_ALL_MODE_CHANGE_FEATURE_TYPES: FeatureEnum[] = [
  FeatureEnum.ProjectBackup,
];

export const MAP_REFRESH_OPTIONS = [
  { labelKey: 'map:refresh_options.15s', value: '15000' },
  { labelKey: 'map:refresh_options.30s', value: '30000' },
  { labelKey: 'map:refresh_options.1m', value: '60000' },
  { labelKey: 'map:refresh_options.5m', value: '300000' },
  { labelKey: 'map:refresh_options.off', value: '0' },
] as const;

export const MAP_TIME_RANGE_OPTIONS = [
  { labelKey: 'map:time_range_options.24h', value: '24h' },
  { labelKey: 'map:time_range_options.7d', value: '7d' },
  { labelKey: 'map:time_range_options.30d', value: '30d' },
  { labelKey: 'map:time_range_options.90d', value: '90d' },
] as const;
